import { LE } from "@/constants/enumsNew";
import type { Lookup, LookupFiltersProp } from "@modernary/mui/components/lookup";
import { computed, ref } from "vue";

export function lookupToDropdown(lookup: Lookup[]) {
  return lookup.map((x) => ({ label: x.description, value: x.murn }));
}

export function lookupToDropdownWithFallback(lookup: Lookup[]) {
  return lookup.map((x) => ({ label: x.longDescription ? x.longDescription : x.description, value: x.murn }));
}

export function getStateOfNevadaFilter(): LookupFiltersProp {
  return ref({
    stateMurn: LE.State.NV,
  });
}
